'use client'

import { Image } from '@vinted/web-ui'

import { ShowAtBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { HoVBrandnewSectionCardModel } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

export const HoVBrandnewSectionCard = ({
  imageMobileUrl,
  imageUrl,
  description,
}: HoVBrandnewSectionCardModel) => (
  <article className="hov__brandnew-section-card">
    <div className="hov__brandnew-section-card-image">
      <ShowAtBreakpoint breakpoint="phones">
        <Image src={imageUrl} scaling="cover" />
      </ShowAtBreakpoint>
      <ShowAtBreakpoint breakpoint="tabletsUp">
        <Image src={imageMobileUrl} scaling="cover" />
      </ShowAtBreakpoint>
    </div>
    <p className="hov__brandnew-section-card-description">{description}</p>
  </article>
)
